import React, { useState } from "react";
import dayjs from "dayjs";
import "dayjs/locale/zh-cn";
import { Calendar as AntCalendar, Button, Row, Select, Typography } from "antd";
import type { Dayjs } from "dayjs";
import dayLocaleData from "dayjs/plugin/localeData";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa6";

dayjs.extend(dayLocaleData);

type Props = {
  handleSelect: any;
  datesWithSlots: any;
  scheduleDate: any;
};
const Calendar: React.FC<Props> = ({
  handleSelect,
  datesWithSlots,
  scheduleDate,
}) => {
  const [selectedDate, setSelectedDate] = useState<any>(null);

  scheduleDate = scheduleDate ? dayjs(scheduleDate * 1000) : dayjs();

  const renderCell = (value: Dayjs) => {
    const dateKey = value.format("DD/MM/YYYY");
    const hasSlots = datesWithSlots[dateKey];
    if (hasSlots) {
      return (
        <div className="custom-cell-render-date custom-cell-render-date-available">
          <div>{value.date()}</div>
        </div>
      );
    }
    return (
      <div className="custom-cell-render-date custom-cell-render-date-not-available">
        <div>{value.date()}</div>
      </div>
    );
  };

  const availableDates = Object.keys(datesWithSlots);
  const disabledDate = (current: dayjs.Dayjs) => {
    return (
      current.isBefore(dayjs(), "day") ||
      !availableDates.includes(current.format("DD/MM/YYYY"))
    );
  };

  return (
    <div className="calendar-container">
      <AntCalendar
        fullscreen={false}
        fullCellRender={renderCell}
        defaultValue={scheduleDate ? scheduleDate : undefined}
        disabledDate={disabledDate}
        onSelect={(date) => setSelectedDate(date.format("DD/MM/YYYY"))}
        headerRender={({ value, onChange }) => {
          const start = 0;
          const end = 12;
          const monthOptions = [];

          let current = value.clone();
          const localeData = value.localeData();
          const months = [];
          for (let i = 0; i < 12; i++) {
            current = current.month(i);
            months.push(localeData.monthsShort(current));
          }

          for (let i = start; i < end; i++) {
            monthOptions.push(
              <Select.Option key={i} value={i} className="month-item">
                {months[i]}
              </Select.Option>
            );
          }
          const year = value.year();
          const options = [];
          for (let i = year - 10; i < year + 10; i += 1) {
            options.push(
              <Select.Option key={i} value={i} className="year-item">
                {i}
              </Select.Option>
            );
          }

          const goToPreviousMonth = () => {
            const newValue = value.clone().subtract(1, "month");
            onChange(newValue);
          };

          const goToNextMonth = () => {
            const newValue = value.clone().add(1, "month");
            onChange(newValue);
          };

          return (
            <div style={{ padding: 8 }}>
              <Typography.Paragraph>{year}</Typography.Paragraph>
              <Typography.Title level={5}>
                {dayjs(value).format("ddd, MMMM DD")}
              </Typography.Title>
              <div className="calendar_month">
                <FaChevronLeft
                  onClick={goToPreviousMonth}
                  style={{ marginRight: 8 }}
                />
                <h5>{dayjs(value).format("MMMM YYYY")}</h5>
                <FaChevronRight
                  onClick={goToNextMonth}
                  style={{ marginLeft: 8 }}
                />
              </div>
            </div>
          );
        }}
      />
      <Row justify={"center"} style={{ marginTop: 20 }}>
        <Button
          onClick={() => {
            if (selectedDate) {
              handleSelect(selectedDate);
            }
          }}
          style={{
            background: "#565656",
            borderRadius: 12,
            boxShadow: "0px 4px 4px 0px #00000040",
            fontWeight: 500,
          }}
          disabled={!selectedDate}
          type="primary"
        >
          Select
        </Button>
      </Row>
    </div>
  );
};

export default Calendar;
